import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { AddressesCollection, AddressModel } from '@models/address';
import { UserModel } from '@models/user';
import { CartModel } from '@models/cart';

import FormDialog from '@components/shared/FormDialog';

import CustomExpansionPanel from '@components/shared/panel/CustomExpansionPanel';
import AddressesList from './AddressesList';
import AddressForm from './AddressForm';

class AddressesContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFormDialogOpen: false,
      addressTemplates: new AddressesCollection(props.addresses.address_templates),
      currentAddress: new AddressModel(props.addresses.current_address),
      statusFilter: 'active',
    };
  }

  handleAddNew = () => {
    this.setState({ isFormDialogOpen: true });
  };

  handleCloseDialog = () => {
    this.setState({ isFormDialogOpen: false });
  };

  updateCurrentAddress = (updatedCurrentAddress) => {
    this.setState({ currentAddress: updatedCurrentAddress });
  }

  handleSuccessSubmit = (newAddres) => {
    this.setState((prevState) => {
      prevState.addressTemplates.models.push(newAddres);
      return { addressTemplates: prevState.addressTemplates, isFormDialogOpen: false };
    });
  }

  handleAddressUpdate = (updatedAddress) => {
    this.setState((prevState) => {
      const addressTemplates = new AddressesCollection(prevState.addressTemplates.models);
      const index = addressTemplates.models.findIndex((addr) => addr.id === updatedAddress.id);
      
      if (index !== -1) {
        addressTemplates.models[index] = updatedAddress;
      }
      
      return { addressTemplates };
    });
  }

  handleFilterChange = (filter) => {
    this.setState({ statusFilter: filter });
  }

  getFilteredAddresses = () => {
    const { addressTemplates, statusFilter } = this.state;

    if (statusFilter === 'all') {
      return addressTemplates;
    }

    const filtered = new AddressesCollection(
      addressTemplates.models.filter((address) => address.status === statusFilter)
    );
    return filtered;
  }

  renderFilterButton = (filter, label) => {
    const { statusFilter } = this.state;
    const isActive = statusFilter === filter;
    
    return (
      <button
        type="button"
        className={`btn btn-xs ${isActive ? 'btn-primary' : 'btn-outline-secondary'}`}
        onClick={() => this.handleFilterChange(filter)}
        style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }}
      >
        {label}
      </button>
    );
  }

  render() {
    const { user, currentCart } = this.props;
    const { isFormDialogOpen, currentAddress } = this.state;

    const isRestrictedCart = currentCart && 
      ['shipping', 'completed'].includes(currentCart.stage);

    const showNewAddressButton = !isRestrictedCart;
    const filteredAddressTemplates = this.getFilteredAddresses();

    return (
      <div className="address-container user-cart-section">
        <CustomExpansionPanel
          id="address-panel"
          headerText="Addresses"
        >
          <div className="panel__content w-100">
            <div className="d-flex justify-content-end align-items-center p-2" style={{ gap: '0.5rem' }}>
              {this.renderFilterButton('active', 'Active')}
              {this.renderFilterButton('inactive', 'Inactive')}
              {this.renderFilterButton('all', 'All')}
              {showNewAddressButton && (
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary"
                  onClick={this.handleAddNew}
                  style={{ marginLeft: '1rem' }}
                >
                  New address
                </button>
              )}
            </div>

            <FormDialog
              title="Enter new shipping address"
              isOpen={isFormDialogOpen}
              onClose={this.handleCloseDialog}
              customClass="dialog__wide"
            >
              <AddressForm
                address={new AddressModel({ user_id: user.id })}
                onCancel={this.handleCloseDialog}
                onSuccessSubmit={this.handleSuccessSubmit}
              />
            </FormDialog>
          </div>
          <AddressesList
            addressTemplates={filteredAddressTemplates}
            currentAddress={currentAddress}
            updateCurrentAddress={this.updateCurrentAddress}
            onAddressUpdate={this.handleAddressUpdate}
          />
        </CustomExpansionPanel>
      </div>
    );
  }
}

AddressesContainer.propTypes = {
  user: PropTypes.instanceOf(UserModel).isRequired,
  currentCart: PropTypes.instanceOf(CartModel),
};

const mapStateToProps = (state) => ({
  user: new UserModel(state.user),
  currentCart: new CartModel(state.carts.current_cart),
});

export default connect(
  mapStateToProps,
)(AddressesContainer);
